new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        updateImage(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = src;
            this.isVideo = false;
        },

        updateVideo(src) {
            if (!this.showOpened)
                this.showOpened = true;
            this.imgSrc = false;
            this.isVideo = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.remove("active");
                }
            } else {
                const otherElement = document.querySelector(".product-detail__fixed--buy");
                if (otherElement) {
                    otherElement.classList.add("active");
                }
            }
        },

        moveToBuy() {
            var productSize = document.getElementById("product-size");
            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth" });
            }
        }
    },
    mounted() {

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });

        const observerCashback = new MutationObserver(() => {
            const cashback = document.querySelector('.section-cashback');
            const price = document.querySelector('.product-detail__header--infoArea-price');
            if (cashback && price) {
                price.insertAdjacentElement('afterend', cashback);
                observerCashback.disconnect();
            }
        });
        observerCashback.observe(document.body, { childList: true, subtree: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

$(document).ready(function () {

    const cashback = document.querySelector('.cashback-themes');
    if (cashback) {
        const cashbackValue = cashback.querySelector('.cashback-themes-value');

        // Converte "R$ 1.234,56" / "10%" em número
        function toNumber(text) {
            if (!text) return NaN;

            let clean = text.replace(/[^\d,.]/g, '');

            if (clean.indexOf(',') > -1) {
                clean = clean.replace(/\./g, '').replace(',', '.');
            }

            return parseFloat(clean);
        }

        function updateCashback() {
            const priceFull = document.querySelector('.price-full');
            if (!cashbackValue || !priceFull) return;

            const percentage = toNumber(cashback.getAttribute('data-percentage'));
            const price = toNumber(priceFull.textContent);

            if (isNaN(percentage) || isNaN(price)) {
                cashbackValue.textContent = '';
                return;
            }

            cashbackValue.textContent = (price * percentage / 100).toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            });
        }

        updateCashback();

        // O preço é re-renderizado ao trocar de variação
        const priceArea = document.querySelector('.price');
        if (priceArea) {
            new MutationObserver(updateCashback).observe(priceArea, {
                childList: true,
                subtree: true,
                characterData: true
            });
        }
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })

    $('#photo-list').slick({
        slidesToShow: 4,
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: false,
        speed: 700,
        vertical: true,
        appendArrows: ".product-detail__showcase--controls-slick",
    })

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    arrows: true
                }
            },
        ]
    })

    $('.product-detail__related--items').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    dots: false,
                    arrows: true,
                }
            },
        ]
    })

    $('.product__colors.attribute').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
    })
})